import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.rule.index'),
        name: 'rule.index',
        component: () =>
            import(
                /* webpackChunkName: "rules" */ '@/views/categories/rules/Index.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.rule.breadcrumb.index'),
                    to: null,
                    disable: false,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.rule.create'),
        name: 'rule.create',
        component: () =>
            import(
                /* webpackChunkName: "rules" */ '@/views/categories/rules/Create.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: { name: 'category.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.rule.breadcrumb.category.edit'),
                    to: {
                        name: 'category.edit',
                        params: {
                            id: 'category_id',
                        },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('routes.rule.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.rule.edit') + '/:id',
        name: 'rule.edit',
        component: () =>
            import(
                /* webpackChunkName: "categories" */ '@/views/categories/rules/Edit.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.rule.breadcrumb.index'),
                    to: { name: 'rules.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.rule.breadcrumb.category.edit'),
                    to: {
                        name: 'category.edit',
                        params: {
                            id: 'category_id',
                        },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('routes.rule.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
